<template>
  <h1>
    Primeiros passos <span class="text-muted text-progress">- {{ this.progress }}% concluído</span>
  </h1>
  <div class="card-list-group mt-4 mb-4">
    <div class="row gx-4 gy-2">
      <div class="col-lg-4 col-md-12 card-list">
        <div
          class="card"
          :class="{ complete: introVideoCompleted }"
          @click="goToIntroVideo()"
        >
          <span class="check-icon"><i class="fa fa-check-circle" /></span>
          <div class="card-icons">
            <i class="fa-solid fa-question icons"></i>
          </div>
          <div class="card-body">
            <h2>O que é e como funciona a Virtap?</h2>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12 card-list">
        <div class="card" :class="{ complete: joinedTelegram }" @click="joinCommunity()">
          <span class="check-icon"><i class="fa fa-check-circle" /></span>
          <div class="card-icons">
            <i class="fa-solid fa-comment icons"></i>
          </div>
          <div class="card-body">
            <h2>Entre na nossa comunidade</h2>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12 card-list">
        <div
          class="card"
          :class="{ complete: introCourseCompleted }"
          @click="goToIntroAVCourse()"
        >
          <span class="check-icon"><i class="fa fa-check-circle" /></span>
          <div class="card-icons">
            <i class="fa-solid fa-graduation-cap icons"></i>
          </div>
          <div class="card-body">
            <h2>Curso Gratuito de Assistência de Virtual</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const INTRO_VIDEO_ID = "pOv1GJe8YB";
const INTRO_AV_COURSE = "intro-av";

export default {
  props: ["telegram_id", "completed_videos", "course_progress"],
  data() {
    return {};
  },
  computed: {
    progress() {
      let count = 0;
      if (this.joinedTelegram) {
        count++;
      }
      if (this.introVideoCompleted) {
        count++;
      }
      if (this.introCourseCompleted) {
        count++;
      }

      return ((count / 3) * 100).toFixed(0);
    },
    joinedTelegram() {
      return this.telegram_id !== null;
    },
    introVideoCompleted() {
      return this.completed_videos.includes(INTRO_VIDEO_ID);
    },
    introCourseCompleted() {
      let introAvProgress = this.course_progress[INTRO_AV_COURSE];
      if (
        introAvProgress &&
        introAvProgress.totalClasses === introAvProgress.completedClasses
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    goToIntroVideo() {
      location.href = "/aula/" + INTRO_VIDEO_ID;
    },
    joinCommunity() {
      location.href = "/comunidade";
    },
    goToIntroAVCourse() {
      location.href = "/curso/" + INTRO_AV_COURSE;
    },
  },
};
</script>
